// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess, markSkipOnCompleteIfOnErrorIsSet, markSkipOnCompleteIfOnSuccessIsSet } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getTopLevelCategories } from "@vanmeter/App/Services/BrandService";
import { IVMICategoryModel } from "@vanmeter/XDL/types";

type Parameter = ApiParameter & HasOnSuccess<IVMICategoryModel[]> & HasOnError<unknown>;
type Props = {
    apiResult: IVMICategoryModel[];
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getTopLevelCategories();
    } catch (error) {
        props.error = error;
    }
};


export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.error);
    }
};
export const chain = [RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const loadTopLevelCategories = createHandlerChainRunner(chain, "loadTopLevelCategories");
export default loadTopLevelCategories;
